import { computed, observable } from "mobx";
import ApiManager from "../mixins/ApiManager";
import { Option } from "../components/common/forms/Interfaces";

interface Country {
  name: string;
  value?: string;
}

class CountriesStore extends ApiManager {
  @observable
  private _countries: Country[] = [];

  @computed
  get all(): Country[] {
    if (this._countries.length === 0) {
      this.getCountries();
    }

    return this._countries;
  }

  private _asOptions: Option[] = [];

  get asOptions(): Option[] {
    if (this._asOptions.length === 0) {
      this._asOptions = this.all.map<Option>((country) => ({
        title: country.name,
        value: country.name,
      }));
    }

    return this._asOptions;
  }

  private getCountries() {
    this.apiManager
      .getCountries()
      .then(async (response) => {
        this._countries = Object.entries(
          (await response.json()) as Record<string, string>
        ).map<Country>(([value, name]) => ({
          value,
          name,
        }));
      })
      .catch(() => {
        this._countries = [];
      });
  }
}

export default CountriesStore;
